import { render, staticRenderFns } from "./ContenidoHelexium.vue?vue&type=template&id=0f9eed05"
import script from "./ContenidoHelexium.vue?vue&type=script&lang=js"
export * from "./ContenidoHelexium.vue?vue&type=script&lang=js"
import style0 from "./ContenidoHelexium.vue?vue&type=style&index=0&id=0f9eed05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports